import { createAction } from '../../libs/saga-utils';

const ns = 'notifications';

export const NOTIFICATION_TYPES = {
  PUSH: `${ns}/PUSH`
};

export const NOTIFICATION_ACTIONS = {
  push: createAction(NOTIFICATION_TYPES.PUSH, (type, text) => ({ type, text }))
};
